import boundary from './settings-boundary-ms'

/** Tetapan -> Perancangan (pelan E). `title` dan `subtitle` ialah teks pelan A, dikekalkan. */
export default {
  title: 'Tetapan Perancangan',
  subtitle: 'Konfigurasi modul Perancangan akan dipaparkan di sini.',
  description: 'Jenis pelan, sistem koordinat, kumpulan pegawai, daftar peta dan had muat naik bagi Perancangan.',
  profiles: 'Jenis pelan',
  profilesHint: 'Pegawai hanya boleh memilih jenis pelan yang didayakan.',
  profilesRequired: 'Dayakan sekurang-kurangnya satu jenis pelan.',
  defaultCrs: 'Sistem koordinat lalai',
  roles: 'Kumpulan pegawai',
  reviewerGroups: 'Kumpulan penyemak',
  reviewerHint: 'Ahli berperanan pentadbir atau penerbit boleh mencipta, mengembalikan dan mencuba semula penyerahan.',
  approverGroups: 'Kumpulan pelulus',
  approverHint: 'Ahli berperanan pentadbir atau penerbit juga boleh meluluskan dan memadam.',
  noGroups: 'Belum ada kumpulan. Cipta di Tetapan → Kumpulan.',
  unknownGroup: 'Kumpulan tidak diketahui atau telah dipadam ({{id}}). Nyahtanda untuk membuangnya.',
  loadingGroups: 'Memuatkan kumpulan…',
  separation: 'Wajibkan pelulus yang berbeza',
  separationHint: 'Pelulus sesuatu versi tidak boleh orang yang menghantarnya.',
  register: 'Pelayan daftar peta',
  registerHint: 'Pelayan PostgreSQL yang menyimpan lapisan perancangan staging dan yang diluluskan.',
  registerManaged: 'Diurus secara automatik: lapisan perancangan penyewa ini disimpan dalam pangkalan data terurusnya.',
  registerNone: 'Tidak dikonfigurasikan',
  registerLocked: 'Dikunci: penyerahan sudah wujud pada pelayan ini.',
  ...boundary,
  selfRegistrationSection: 'Akaun pemohon',
  selfRegistration: 'Benarkan pemohon mendaftar sendiri',
  selfRegistrationHint:
    'Perunding boleh memohon akaun pemohon pada halaman awam. Setiap permohonan menunggu kelulusan, dan slot pengguna hanya digunakan apabila ia diluluskan.',
  selfRegistrationLink: 'Halaman pendaftaran awam',
  selfRegistrationLinkHint: 'Kongsi pautan ini dengan perunding. Ia menerima permohonan setelah tetapan ini disimpan.',
  selfRegistrationCopy: 'Salin pautan',
  selfRegistrationCopied: 'Disalin',
  allowApproverProvisioning: 'Benarkan pegawai pelulus meluluskan pendaftaran',
  allowApproverProvisioningHint:
    'Jika tidak, hanya pentadbir penyewa boleh meluluskan pendaftaran pemohon. Pegawai yang hanya penyemak tidak boleh sama sekali.',
  allowApproverProvisioningWarning:
    'Setiap kelulusan menggunakan satu slot pengguna pemerhati berbayar. Apabila ini dihidupkan, pegawai pelulus boleh menggunakan slot tanpa pentadbir.',
  maxUpload: 'Saiz muat naik maksimum (MB)',
  maxUploadHint: 'Antara 1 hingga 200 MB.',
  maxUploadInvalid: 'Masukkan nombor bulat antara 1 hingga 200.',
  save: 'Simpan',
  saving: 'Menyimpan…',
  saved: 'Tetapan disimpan.',
} as const
